<ion-app>
  <app-confirm-delete-alert #notAvaible></app-confirm-delete-alert>
  <app-confirm-delete-alert #updateAlerte></app-confirm-delete-alert>
  <ion-menu style="padding-bottom: 20px;" side="start" menuId="menuNavi" contentId="main">

    <ion-header class="ion-no-border">
      <ion-menu-toggle>
        <ion-toolbar>
          <ion-item lines="none" style="margin-top: 1rem;">
            <ion-button fill="none" (click)="manager.Navi.closeMenu()" slot="start" style="z-index: 9999">
              <ion-icon slot="icon-only" name="menu" color="primary"></ion-icon>
            </ion-button>
          </ion-item>
          <img src="assets/svg/KUERLOG_LogoHorizontal_RVB_fond-clair.svg" alt="">
        </ion-toolbar>
      </ion-menu-toggle>
    </ion-header>

    <ion-content>
      <ion-list lines="none" class="listMargin">
        <ion-item-divider mode="md"></ion-item-divider>
        <ion-menu-toggle>
          <ion-item routerLinkActive="menuActiveItem" itemid="admin" routerLink="admin"
            *ngIf="manager.Usr.HasAdminRight"><ion-label>{{traduction.Parse("STR_ADMIN_VIEW")}}</ion-label><ion-icon
              name="desktop-outline" slot="start"></ion-icon></ion-item>
          <ion-item routerLinkActive="menuActiveItem" itemid="asks"
            routerLink="asks"><ion-label>{{traduction.Parse("STR_HOME")}}</ion-label><ion-icon name="home-outline"
              slot="start"></ion-icon></ion-item>
          <ion-item routerLinkActive="menuActiveItem" itemid="scan"
            routerLink="scan"><ion-label>{{traduction.Parse("STR_SCAN")}}</ion-label><ion-icon name="qr-code-outline"
              slot="start"></ion-icon></ion-item>
          <ion-item routerLinkActive="menuActiveItem" itemid="crea"
            routerLink="crea"><ion-label>{{traduction.Parse("STR_CREA_ASK")}}</ion-label><ion-icon
              name="clipboard-outline" slot="start"></ion-icon></ion-item>
        </ion-menu-toggle>

        <ion-item-divider mode="md"></ion-item-divider>

        <ion-menu-toggle *ngIf="user.isLoged ">
          <ion-item routerLinkActive="menuActiveItem" itemid="account"
            routerLink="account/"><ion-label>{{traduction.Parse("STR_MY_PROFILE")}}</ion-label><ion-icon
              name="person-outline" slot="start"></ion-icon></ion-item>
          <ion-item routerLinkActive="menuActiveItem" itemid="contacts"
            routerLink="contacts/"><ion-label>{{traduction.Parse("STR_CONTACTS")}}</ion-label><ion-icon
              name="people-outline" slot="start"></ion-icon></ion-item>

        </ion-menu-toggle>
        <ion-menu-toggle *ngIf="!user.isLoged ">
          <ion-item routerLinkActive="menuActiveItem" itemid="login" routerLink="login/"><ion-label>
              {{traduction.Parse("STR_LOGIN")}}</ion-label><ion-icon name="log-in-outline"
              slot="start"></ion-icon></ion-item>
          <ion-item routerLinkActive="menuActiveItem" itemid="register"
            routerLink="register/"><ion-label>{{traduction.Parse("STR_REGISTER")}}</ion-label><ion-icon
              name="person-add-outline" slot="start"></ion-icon></ion-item>
        </ion-menu-toggle>

        <ion-item-divider mode="md"></ion-item-divider>

        <ion-item (click)="user.viewCgu()" style="cursor: pointer">
          <ion-label>{{traduction.Parse("STR_TERMS")}}</ion-label>
          <ion-icon name="book-outline" slot="start"></ion-icon>
        </ion-item>

        <a href="" (click)="menuNavi.openLink('https://app.capilite.fr/policy/confidentiality.html', $event)"
          style="text-decoration: none;">
          <ion-item>
            <ion-label class="ion-text-wrap">{{traduction.Parse("STR_CONFIDENTIALITY")}}</ion-label>
            <ion-icon name="document-text-outline" slot="start"></ion-icon>
          </ion-item>
        </a>
        <a href="" (click)="menuNavi.openLink('https://capilite.fr/', $event)" style="text-decoration: none;">
          <ion-item>
            <ion-label class="ion-text-wrap">{{traduction.Parse("STR_ABOUT")}}</ion-label>
            <ion-icon name="help-circle-outline" slot="start"></ion-icon>
          </ion-item>
        </a>


        <ion-item (click)="user.presentLanguageActionSheet()" style="cursor: pointer;position:relative">
          <ion-icon slot="start" src="assets/flags/{{traduction.Parse('STR_FLAG')}}.svg"></ion-icon>
          <ion-label class="uppercase">{{traduction.currentLanguage}}</ion-label>
          <ion-icon slot="end" name="chevron-down-outline"></ion-icon>
        </ion-item>
        <ion-item *ngIf="manager.Tool.getVersion() !='browser'">
          <ion-label
            color="medium">{{manager.Trad.Parse("STR_VERSION",{version:manager.Tool.getVersion()})}}</ion-label>
        </ion-item>
      </ion-list>
    </ion-content>

    <ion-footer class="ion-no-border">
      <ion-list lines="none" class="listMargin">
        <ion-menu-toggle *ngIf="user.isLoged">
          <ion-item color="danger" style="border-radius: 10px;" (click)="user.Logout()"
            button>{{traduction.Parse("STR_LOGOUT")}}<ion-icon name="power-outline" slot="start"></ion-icon></ion-item>
        </ion-menu-toggle>
      </ion-list>
    </ion-footer>
  </ion-menu>

  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>